import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Link, useNavigate } from "react-router-dom";
import productStore from "../stores/ProductStore"; 
import Header from "../Components/Header";
import ProductService from "../Services/ProductService";
import Canvas from "../assets/img/canvas-img.jpg";
import PhotoBook from "../assets/img/photobook.jpg";
import CartService from "../Services/CartService";
import YourCart from "./Account/YourCart";

const headerLinks = [{ name: "Home", href: "/" }];
interface ProductType {
  productTypeID: number;
  productTypeName: string;
}


const Home = observer(() => {
  const [activeSection, setActiveSection] = useState(1);
  const [showButton, setShowButton] = useState(false);
  const [showBorder, setShowBorder] = useState(0);
  const [productTypes, setProductTypes] = useState<ProductType[]>([]);
  const navigate = useNavigate();

  // Fetch product types on component mount
  useEffect(() => {
    const fetchProductTypes = async () => {
      try {
        const prodTypes = await ProductService.GetProductTypes();
        setProductTypes(prodTypes || []); 
      } catch (error) {
        console.error("Error fetching product types:", error);
      }
    };
    fetchProductTypes();
  }, []);

  const showSection = (sectionNumber: number) => {
    setActiveSection(sectionNumber);
    setShowButton(false);
    setShowBorder(0);

    if (showBorder === 2 && productStore.getSelectedProductId === 2) {
      navigate(process.env.REACT_APP_PublicPath + "/orientation", { replace: false });
    }else{
      navigate(process.env.REACT_APP_PublicPath + "/photobook", { replace: false });
    }
  };

  const handleRadioButton = (value: boolean, index: number, productTypeId: number) => {
    setShowButton(value);
    setShowBorder(index);
    productStore.setSelectedProductId(productTypeId); // Save the selected product in the MobX store
  };
  const [cartItemCount, setCartItemCount] = useState(0);

  // Fetch the cart count initially
  const fetchCartCount = async () => {
    try {
      const { CartCount } = await CartService.GetCartCount();
      setCartItemCount(CartCount);
    } catch (error) {
      console.error("Error fetching cart count:", error);
    }
  };

  useEffect(() => {
    fetchCartCount(); // Fetch cart count when the component mounts
  }, []);

  return (
    <>
      {/* <YourCart cartItemsCount={cartItemCount} setCartItemCount={setCartItemCount} /> */}
      <Header cartItemsCount={cartItemCount} title="My Website" links={headerLinks} />
      {activeSection === 1 && (
        <section className="ProductType">
          <div className="mx-auto max-w-7xl mt-10 mb-40 px-4 sm:px-6 lg:px-8">
            <h1 className="text-3xl font-normal text-center">Select a Product Type</h1>
            <div className="flex justify-center mt-8">
              {productTypes.map((productType, index) => (
                <div
                  key={productType.productTypeID}
                  className={
                    (showBorder === index + 1 ? "border-slate-sel" : "") +
                    " mr-4 block max-w-sm p-6 text-center bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700"
                  }
                >
                  <div className="flex flex-col items-center">
                    <img
                      src={productType.productTypeID === 1 ? PhotoBook : Canvas}
                      alt="Xceedprintsolutions"
                      className="w-auto"
                    />
                    <h5 className="mb-1 text-xl font-medium text-gray-900 dark:text-white pt-3">
                      {productType.productTypeName}
                    </h5>
                    <span className="text-sm text-gray-500 dark:text-gray-400 pt-3 pb-6">
                      {productType.productTypeID === 1
                        ? "Create a custom photo book to celebrate your moments."
                        : "Create life-size wood framed canvas with your photos."}
                    </span>
                    <span className="pt-0">
                      <input
                        type="radio"
                        className="h-5 w-5"
                        onClick={() => handleRadioButton(true, index + 1, productType.productTypeID)}
                        name="producttype"
                      />
                    </span>
                  </div>
                </div>
              ))}
            </div>
            {showButton && (
              <div className="flex justify-center">
                <div className="mt-10 w-80">
                  <button
                    type="submit"
                    className="w-full py-2 px-4 bg-green font-medium text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    onClick={() => showSection(2)}
                  >
                    Continue
                  </button>
                </div>
              </div>
            )}
          </div>
        </section>
      )}
    </>
  );
});

export default Home;